module.exports = __webpack_public_path__ + "img/bq.ba04ca66.png";